import React from 'react';
import { useTable, Column } from 'react-table';
import './CustomTable.css';

interface CustomTableProps<T extends object> {
    data?: T[];
    columns?: Column<T>[];
    style?: React.CSSProperties; // Add style prop to allow external styling
}

const CustomTable = <T extends object>({
    data = [],
    columns = [],
    style,
}: CustomTableProps<T>): JSX.Element => {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data });

    if (columns.length === 0 || data.length === 0) {
        return <div className="empty-table-message">Custom Table without Data</div>;
    }

    return (
        <div className="custom-table-wrapper" style={style}>
            <table {...getTableProps()} className="custom-table">
                <thead>
                    {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => (
                                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {rows.map(row => {
                        prepareRow(row);
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map(cell => (
                                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                ))}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default CustomTable;
